<template>
  <div class="jumbotron">
    <div class="row">
      <div class="col-12 jumbotron_text">
        {{data.delivery_type}} /
        <span v-if="data.vehicle_type">{{data.vehicle_type.name}}</span>
        <button v-if="isDispatched && allowRetryFreightProvision && !disableFreightProvisionRetry"
          class="btn btn-secondary f-right"
          @click="$emit('retry-freight-provision')">
          RETRIGGER FREIGHT PROVISION
        </button>
      </div>
      <div class="col-auto" >
        <div class="row" v-if="isPerTrip">
          <div class="col-auto">
            <div class="jumbotron_text">
              Vehicle
              <br />Material
            </div>
          </div>
          <div class="col-auto no-padding">
            <span class="jumbotron_badge_warning">Wt</span>
            <!-- This corresponds to vehicle details-->
            <span class="jumbotron_badge_text">{{data.vehicle_type.kg}} KG</span>
            <br />
            <span class="jumbotron_badge_info">Wt</span>
            <!-- This corresponds to material details-->
            <span class="jumbotron_badge_text">{{data.capacity.weight}} KG</span>
          </div>
          <div class="col-auto">
            <span class="jumbotron_badge_warning">Vl</span>
            <!-- This corresponds to vehicle details-->
            <span class="jumbotron_badge_text">{{data.vehicle_type.cft}} CFT</span>
            <br />
            <span class="jumbotron_badge_info">Vl</span>
            <!-- This corresponds to material details-->
            <span class="jumbotron_badge_text">{{data.capacity.volume}} CFT</span>
          </div>
        </div>
        <div class="col-auto jumbotron_text no-padding" v-if="data.freight_invoice_ratio">
          <span>
              Freight-To-Invoice Ratio :
              <strong class="text-bold">{{Number(data.freight_invoice_ratio).toFixed(2)}}</strong>
          </span>
      </div>
      </div>
      <div class="col-auto jumbotron_block" v-if="isPerTrip && !configRunSection">
        <div class>
          <div class="jumbotron_block_success">
            Xw = {{data.capacityDiff.weight}},
            Xv = {{data.capacityDiff.volume}} => X{{calculationBasedAttribute.charAt(0)}} is greater
            <Tooltip class="item" effect="dark" placement="bottom" :open-delay="300">
              <div slot="content" class="jumbotron tooltipcontent">
                Xw: Total material weight / Total vehicle weight
                <br />Xv: Total material volume / Total vehicle volume
              </div>
              <button>
                <svgicon name="info-black" width="12" height="12" :original="true" />
              </button>
            </Tooltip>
          </div>
          <div class="jumbotron_block_text" v-if="calculationBasedAttribute">
            Individual freight for materials will be based on <b>{{calculationBasedAttribute}}</b>
          </div>
        </div>
      </div>

      <div class="col right-auto" v-if="isPerTrip && data.freight_rate">
        <div class="jumbotron_text">Updated Charges</div>
        <div class="jumbotron_amount">Rs. {{Number(data.freight_rate).toFixed(2)}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data', 'isPerTrip', 'calculationBasedAttribute', 'configRunSection', 'disableFreightProvisionRetry'],
  computed: {
    isDispatched() {
      const orderStatus = this.data.status;
      return (
        this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus)
      );
    },
    allowRetryFreightProvision() {
      return this.data.allowRetryFreightProvision && this.$hasPermission('retry_freight_provision');
    },
  },
};
</script>
